module.exports = __webpack_public_path__ + "img/Weapon_155.f5eb543f.png";